export default __webpack_public_path__ + "static/media/Instgram.1209aafd.svg";